import React from "react";
import useStyles from "./styles";

export default function MobileButtonContainer({ children }) {
  const classes = useStyles();
  return <div className={classes.mobileButtonContainer}>{children}</div>;
}
